import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import {ReactComponent as BatchUploadFormat} from '../../../../../../images/batchuploadformat-sample.svg'

export default function BatchUploadFormatGuide() {
    return (
        <div>
            <Typography variant="subtitle1" style={{color: '#098447'}}>
                Step 1 of 4: Format Spreadsheet
            </Typography>
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '100%',
                    margin: '5px 0s',
                }}
            >
                <BatchUploadFormat style={{width: '450px'}} />
                <ol>
                    <li>
                        Type the header ID in Row 1 above your list of
                        attendees.
                    </li>
                    <li>
                        List all attendees in individual cells in the same
                        column, underneath the ID header.
                    </li>
                    <li>
                        Only EUIDs and ID Numbers can be processed, don’t
                        include names.
                    </li>
                </ol>
            </Box>
        </div>
    )
}
